export default __webpack_public_path__ + "static/project-diagram-cross_1x.png";